import { Bot, Users, Cpu, GitBranch, Play, Save } from 'lucide-react';
import Button from '../Button';
import { useState } from 'react';
import Toast from '../Toast';
import workflowService from '../../services/workflowService';
import { deepEqualArray } from '../../helpers/common';

export const NodeToolbar = ({ onAddNode, nodesData, edgesData, workflowId, isEdit, setSelectedNode }) => {
  const [loading, setLoading] = useState(false);

  function generateSteps(nodes, edges) {
    const nodeMap = Object.fromEntries(nodes.map(n => [n.id, n]));

    let steps = [];

    const startNode = nodes.find(n => n.data.type === 'start' || n.id === 'start-1');
    if (!startNode) return steps;

    let currentNodeId = startNode.id;

    while (true) {
      const nextEdge = edges.find(e => e.source === currentNodeId);
      if (!nextEdge) break;

      const nextNode = nodeMap[nextEdge.target];
      if (!nextNode) break;

      const stepData = nextNode.data;

      let formattedStep = {
        type: stepData?.type,
        step_name: stepData?.label || '',
        step_description: stepData?.instructions || stepData?.step_description || '',
      };

      if (stepData.type === 'agent') {
        if (typeof stepData?.agentId === 'object') {
          formattedStep.agent_id = stepData?.agentId?.value || '';
        } else {
          formattedStep.agent_id = stepData?.agent_id || stepData?.agentId || '';
        }
      }

      if (stepData.type === 'team') {
        if (typeof stepData?.teamId === 'object') {
          formattedStep.team_id = stepData?.teamId?.value || '';
        } else {
          formattedStep.team_id = stepData?.team_id || stepData?.teamId || '';
        }
      }

      if (stepData.type === 'llm') {
        if (typeof stepData?.model === 'object') {
          formattedStep.model = stepData?.model?.value || '';
        } else {
          formattedStep.model = stepData?.model || '';
        }
        formattedStep.prompt = stepData?.prompt || '';
      }

      steps.push(formattedStep);
      currentNodeId = nextNode.id;
    }

    return steps;
  }

  const handlePreview = async () => {
    setLoading(true);
    try {
      const steps = generateSteps(nodesData, edgesData);

      if (deepEqualArray(isEdit?.steps, steps)) {
        Toast({
          type: 'error',
          message: 'No changes found!',
        });
      } else {
        const editPayload = {
          steps,
          workflow_id: workflowId,
        };
        const res = await workflowService.updateWorkflow(editPayload);
        Toast({
          type: 'success',
          message: res.detail || 'Workflow updated successfully!',
        });
      }
      setLoading(false);
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message || 'Something went wrong!',
      });
      setLoading(false);
    }
  };

  return (
    <div className="absolute top-4 right-4 z-10">
      <div className="bg-transparent border border-[rgba(157,157,157,0.5)] rounded-lg p-2 shadow-lg flex gap-2">
        <Button
          size="sm"
          variant="outline"
          onClick={handlePreview}
          loader={loading}
          className="flex !bg-transparent !text-black flex-col h-auto py-2 px-3">
          <Save className="h-5 w-5 mb-1" />
          <span className="text-xs">Save</span>
        </Button>

        <Button
          size="sm"
          variant="outline"
          onClick={() =>
            setSelectedNode({
              data: {
                type: 'chat',
                label: 'Chat',
              },
            })
          }
          loader={loading}
          className="!bg-transparent !text-black flex flex-col h-auto py-2 px-3">
          <Play className="h-5 w-5 mb-1" />
          <span className="text-xs">Run</span>
        </Button>

        <Button
          size="sm"
          variant="outline"
          onClick={() => onAddNode('agent')}
          className="!bg-transparent !text-black flex flex-col h-auto py-2 px-3">
          <Bot className="h-5 w-5 mb-1" />
          <span className="text-xs">Agent</span>
        </Button>

        <Button
          size="sm"
          variant="outline"
          onClick={() => onAddNode('team')}
          className="!bg-transparent !text-black flex flex-col h-auto py-2 px-3">
          <Users className="h-5 w-5 mb-1" />
          <span className="text-xs">Team</span>
        </Button>

        <Button
          size="sm"
          variant="outline"
          onClick={() => onAddNode('llm')}
          className="!bg-transparent !text-black flex flex-col h-auto py-2 px-3">
          <Cpu className="h-5 w-5 mb-1" />
          <span className="text-xs">LLM</span>
        </Button>

        {/* <Button
          size="sm"
          variant="outline"
          onClick={() => onAddNode('condition')}
          className="flex flex-col h-auto py-2 px-3">
          <GitBranch className="h-5 w-5 mb-1" />
          <span className="text-xs">Condition</span>
        </Button> */}
      </div>
    </div>
  );
};
